const gizleAlanlar = new Set(["APISAHIBI", "apisahibi", "SONUCSAYISI", "sonucsayisi", "APITELEGRAMGRUBU", "apitelegramgrubu"]);

function getAntiCurlHeaders() {
    const token = localStorage.getItem("sorgu_token") || "";
    const ts = Date.now();
    const sign = btoa(ts + token);
    return {
        "X-Req-Ts": ts.toString(),
        "X-Req-Sign": sign
    };
}

export async function apiGiris(kullanici, sifre) {
    const fd = new FormData();
    fd.append("kullanici", kullanici);
    fd.append("sifre", sifre);
    const yanit = await fetch("/mauro.php?api=giris", { method: "POST", body: fd, credentials: "include" });
    const json = await yanit.json();
    if (json.basarili && json.token) {
        localStorage.setItem("sorgu_token", json.token);
    }
    return json;
}

export async function apiCikis() {
    localStorage.removeItem("sorgu_token");
    await fetch("/mauro.php?api=cikis", { method: "POST", credentials: "include" });
}

export async function apiDurum() {
    const token = localStorage.getItem("sorgu_token");
    const headers = token ? { "Authorization": `Bearer ${token}` } : {};
    Object.assign(headers, getAntiCurlHeaders());
    const yanit = await fetch("/mauro.php?api=durum", { headers, credentials: "include" });
    return yanit.json();
}

export async function apiSorgu(tip, veriler) {
    const fd = new FormData();
    for (const anahtar in veriler) {
        fd.append(anahtar, veriler[anahtar]);
    }
    const token = localStorage.getItem("sorgu_token");
    const headers = token ? { "Authorization": `Bearer ${token}` } : {};
    Object.assign(headers, getAntiCurlHeaders());
    const yanit = await fetch("/gala.php?q=" + tip, { method: "POST", body: fd, headers, credentials: "include" });
    const ham = await yanit.text();
    try {
        const json = JSON.parse(ham);
        if (json.error) throw new Error(json.error === "VIP_REQUIRED" ? "Bu sorgu için VIP yetkiniz gerekiyor." : json.error);
        return temizleVeri(json);
    } catch (hata) {
        if (hata.message) throw hata;
        throw new Error("Beklenmeyen sunucu yanıtı.");
    }
}

function temizleVeri(veri) {
    if (!veri || typeof veri !== "object") return veri;
    if (Array.isArray(veri)) {
        return veri.map((satir) => {
            if (typeof satir === "object" && satir !== null) {
                const temiz = {};
                for (const a in satir) {
                    if (!gizleAlanlar.has(a)) temiz[a] = satir[a];
                }
                return temiz;
            }
            return satir;
        });
    }
    const anahtarlar = Object.keys(veri);
    const kucuk = {};
    anahtarlar.forEach((a) => { kucuk[a.toLowerCase()] = a; });
    if (kucuk["veri"]) return temizleVeri(veri[kucuk["veri"]]);
    if (veri.data && (Array.isArray(veri.data) || typeof veri.data === "object")) {
        if (anahtarlar.length <= 3) return temizleVeri(veri.data);
    }
    const temiz = {};
    for (const a in veri) {
        if (!gizleAlanlar.has(a)) temiz[a] = veri[a];
    }
    return temiz;
}
